/* eslint-disable */
export const FaqData = [
  {
    "id": 1,
    "header": "O que é o Eu Ajudo?",
    "body": "O Eu Ajudo é um serviço feito para a comunidade, que você pode cadastrar os pontos de vacinas em sua cidade.",
  },
  {
    "id": 2,
    "header": "Por que devo colaborar?",
    "body": "Você estará ajudando a sua comunidade ao cadastrar os pontos de vacina em sua cidade. Proporcionado um bom vinculo com sua comunidade, além de facilitar na hora do pessoal se vacinar.",
  },
  {
    "id": 3,
    "header": "Suporte ao usuário",
    "body": "Se você estiver com dificuldades ou problemas para acessar o nosso site do Eu Ajudo: muitas das vezes é só esperar; talvez nosso sistema esteja com um problema temporário. Verifique se há interrupções ou inatividade nos nossos serviços, caso continue entre contato ou vá para a central de ajuda e preencha alguns formulários e deixe bem explícito os tipos de erros.",
  },
];